export const serialize = nodes => {
  return nodes
    .map(n => {
      if (n.type === 'image') {
        const url = n.url?.replace(/\\/g, '') || ''
        return `<img src="${url}" alt="" class="max-w-full rounded-lg my-4" />`
      }

      if (n.type === 'video') {
        const url = n.url?.replace(/\\/g, '') || ''
        return `<video controls class="w-full rounded-lg aspect-video my-4"><source src="${url}" /></video>`
      }

      if (n.type === 'heading') {
        return `<h2 class="text-2xl font-bold my-4">${serialize(n.children)}</h2>`
      }

      if (n.type === 'paragraph') {
        return `<p class="my-2">${serialize(n.children)}</p>`
      }

      if (n.text) {
        let text = n.text
        if (n.bold) text = `<strong>${text}</strong>`
        if (n.italic) text = `<em>${text}</em>`
        if (n.underline) text = `<u>${text}</u>`
        return text
      }

      return ''
    })
    .join('')
}